export default __webpack_public_path__ + "8832ac2ef05711bbc6312ca1b8e03dd5.png";